const firebaseConfig = {
  apiKey: "AIzaSyBTCJuCgLCjLtBd5tR-UMCN0OSugYEKi0A",
  authDomain: "goldenkey-19edf.firebaseapp.com",
  projectId: "goldenkey-19edf",
  storageBucket: "goldenkey-19edf.firebasestorage.app",
  messagingSenderId: "1017222339912",
  appId: "1:1017222339912:web:12c2c7a8b31b81475f677d",
  measurementId: "G-V1EW83JEFR"
};

export default firebaseConfig